import { logout } from '@/services/api/authentication_service';

export default {
  name: 'errors',
  error: (payload) => {
    if (payload.response.status === 401) {
      logout();
      return {
        request: {
          authorized: false,
        },
      };
    } else {
      const { data } = payload.response;
      if (!data.errors) {
        console.log('Unidentified error');
        console.log(payload);
      } else {
        return data.errors[0];
      }
    }
  },
};
